"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./file-management.roles"), exports);
__exportStar(require("./hr.roles"), exports);
__exportStar(require("./inventory.roles"), exports);
__exportStar(require("./partners.roles"), exports);
__exportStar(require("./product-implementation.roles"), exports);
__exportStar(require("./production.roles"), exports);
__exportStar(require("./products.roles"), exports);
__exportStar(require("./request-for-quote.roles"), exports);
__exportStar(require("./sales-order.roles"), exports);
__exportStar(require("./setup.roles"), exports);
__exportStar(require("./shipment.roles"), exports);
__exportStar(require("./traverse-frontend.roles"), exports);
__exportStar(require("./user-management.roles"), exports);
//# sourceMappingURL=index.js.map